<template>
  <span class="svg-ico-exclamation-circle">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.26562 12.8281C1.26562 18.7423 6.10141 23.5781 12.0156 23.5781C17.9298 23.5781 22.7656 18.7423 22.7656 12.8281C22.7656 6.91391 17.9298 2.07812 12.0156 2.07812C6.10141 2.07812 1.26562 6.91391 1.26562 12.8281ZM12.0156 22.0781C6.92984 22.0781 2.76562 17.9139 2.76562 12.8281C2.76562 7.74234 6.92984 3.57812 12.0156 3.57812C17.1014 3.57812 21.2656 7.74234 21.2656 12.8281C21.2656 17.9139 17.1014 22.0781 12.0156 22.0781Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0208 7.77806C12.435 7.77806 12.7708 8.11385 12.7708 8.52806V13.7781C12.7708 14.1923 12.435 14.5281 12.0208 14.5281C11.6065 14.5281 11.2708 14.1923 11.2708 13.7781V8.52806C11.2708 8.11385 11.6065 7.77806 12.0208 7.77806Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0208 15.978C12.573 15.978 13.0208 16.4257 13.0208 16.978V17.078C13.0208 17.6302 12.573 18.078 12.0208 18.078C11.4685 18.078 11.0208 17.6302 11.0208 17.078V16.978C11.0208 16.4257 11.4685 15.978 12.0208 15.978Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
